import { clientConfigApi } from "./clientConfig";

export const {
  useGetClientConfigQuery,
  useCreateClientConfigMutation,
  useUpdateClientConfigMutation
} = clientConfigApi;
